/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import { Card, CardBody, Col, Row, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import CountUp from "react-countup";
import { useSelector, useDispatch } from "react-redux";


const CountUpComponent = ({ end }) => {
  const [endValue, setEndValue] = useState(0);

  useEffect(() => {
    setEndValue(end);
  }, [end]);

  return <CountUp start={0} end={endValue} duration={3} />;
};

const Widget = ({ widget }) => {
  const widgetConfig = {
    id: widget.id,
    label: widget.label,
    badge: widget.badgeIcon,
    counter: widget.counter,
    separator: ",",
  };

  return (
    <Col xl={3} md={6}>
      <Card>
        <CardBody style={{ height: "100px", overflow: "hidden" }}>
          <div className="d-flex align-items-center counter-widget">
            <div className="flex-grow-1">
              <p className="text-uppercase fw-semibold fs-14 text-muted mb-1">
                {widgetConfig.label || "data"}
              </p>
              <h2 className="mb-0 mr-2">
                <CountUpComponent end={widgetConfig.counter || "data"} />
              </h2>
            </div>
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                <i className={"align-middle " + widgetConfig.badge || "data"}></i>
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

const TileBoxs = () => {
  const [activeTab, setActiveTab] = useState("statistics");
  const dispatch = useDispatch();

  const dashboardCount = useSelector((state) => state?.Dashboard?.data);
  const topMiners = useSelector((state) => state?.Dashboard?.users); // Get topMiners from the state



  useEffect(() => {
    if (topMiners) {
    }
  }, [topMiners]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const widgetData = useMemo(
    () => [
      {
        id: 1,
        label: "Total Users",
        badgeIcon: "las la-users",
        counter: dashboardCount?.totalUsers || 10,
      },
      {
        id: 2,
        label: "Approved Users",
        badgeIcon: "bx bx-user-check",
        counter: dashboardCount?.totalApprovedUsers || 20,
      },
      {
        id: 3,
        label: "Pending Users",
        badgeIcon: "bx bx-user-minus",
        counter: dashboardCount?.totalPendingUsers || 5,
      },
      {
        id: 4,
        label: "Total Balance",
        badgeIcon: "las la-piggy-bank",
        counter: (dashboardCount?.totalMinedBalance) || 0,
      },
      // {
      //   id: 5,
      //   label: "Today’s Mined Balance",
      //   badgeIcon: "bx bx-wallet-alt",
      //   counter: (dashboardCount?.todayMinedBalance) || 0,
      // },
      // {
      //   id: 6,
      //   label: "Withdraw Requests",
      //   badgeIcon: "bx bx-git-pull-request",
      //   counter: dashboardCount?.totalWithdrawnRequests || 0,
      // },
      // {
      //   id: 7,
      //   label: "Today’s Withdraw Requests",
      //   badgeIcon: "bx bx-coin",
      //   counter: parseFloat(dashboardCount?.todayWithdrawnRequests) || 0,
      // },
    ],
    [dashboardCount]
  );

  return (
    <React.Fragment>
      <Nav tabs className="nav nav-tabs nav-border-top nav-border-top-primary mb-4 mt-3">
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "statistics" })}
            onClick={() => toggleTab("statistics")}
          >
            Statistics
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="statistics">
          <Row>
            {widgetData.length > 0 ? (
              widgetData.map((widget) => <Widget key={widget.id} widget={widget} />)
            ) : (
              <p>No widget data available.</p>
            )}
          </Row>
        </TabPane>


      </TabContent>
    </React.Fragment>


  );
};

export default TileBoxs;
